import script from "./ImportModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportModal.vue?vue&type=script&setup=true&lang=js"

import "./ImportModal.vue?vue&type=style&index=0&id=04497fef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04497fef"]])

export default __exports__